import { render, staticRenderFns } from "./NewGame.vue?vue&type=template&id=61e4d367&"
import script from "./NewGame.vue?vue&type=script&lang=js&"
export * from "./NewGame.vue?vue&type=script&lang=js&"
import style0 from "./NewGame.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports